import React from "react";
import styled from "styled-components";

const StepsTimeline = ({ steps }) => {
  return (
    <Wrapper>
      {steps.map((step, index) => (
        <StepCard key={index}>
          <StepIcon>{index + 1}</StepIcon>
          <Content>
            <h5>{step.title}</h5>
            <p>{step.desc}</p>
          </Content>
        </StepCard>
      ))}
    </Wrapper>
  );
};

export default StepsTimeline;

export const Wrapper = styled.div`
  position: relative;
  margin: 40px 0;
  padding-left: 35px;

  &::before {
    content: "";
    position: absolute;
    left: 14px;
    top: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(to bottom, #005f73, #005f73);
    opacity: 0.3;
  }
`;

export const StepCard = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  margin-bottom: 28px;

  padding: 18px 20px;
  border-radius: 12px;
  background: #ffffff;

  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 30px rgba(0, 200, 83, 0.15);
  }
`;

export const StepIcon = styled.div`
  position: absolute;
  left: -35px;
  top: 20px;

  width: 28px;
  height: 28px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(135deg, #005f73, #0c292f);
  color: #fff;
  font-size: 14px;
  font-weight: bold;

  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 200, 83, 0.4);
`;

export const Content = styled.div`
  h5 {
    margin: 0 0 6px;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #555;
    line-height: 1.6;
  }
`;
